import { defineComponent } from "vue";
import InfoOverlay from "../overlay/info/InfoOverlay.vue";
import AccountOverlay from "../overlay/auth/AccountOverlay.vue";
export default defineComponent({
    methods: {
        onClickLive: function () {
            this.$router.push("/live");
        },
        onReload: function () {
            window.location.reload();
        },
        onAccount: function () {
            this.$emit("onAccount", "svg/account.svg", "Account", AccountOverlay);
        },
        onInfo: function () {
            this.$emit("onInfo", "svg/info.svg", "Info", InfoOverlay);
        },
    },
    emits: ["onInfo", "onSignIn", "onSignUp", "onAccount"],
});
